import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';

const AgentIcon = ({ widthSize = 46, isFromGraph = false }) => {
  if (isFromGraph) {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto',
          padding: '8px',
          transform: isHovered ? 'scale(1.3)' : 'scale(1)',
          transition: 'transform 0.2s ease, background-color 0.2s ease',
          ...(isHovered && {
            borderRadius: '50%',
            backgroundColor: 'rgba(167, 139, 250, 0.2)'
          })
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <SvgIcon
          className="svg-inline--fa fa-robot fa-w-20 sidepanel"
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="robot"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          style={{
            width: '1em',
            height: '1em',
            fontSize: '50px',
            transition: 'color 0.2s ease, transform 0.2s ease'
          }}
        >
          <path
            fill="currentColor"
            // eslint-disable-next-line max-len
            d="M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
          />
        </SvgIcon>
      </div>
    );
  }

  // Original rendering when isFromGraph is false
  return (
    <SvgIcon
      className="svg-inline--fa fa-robot fa-w-20 sidepanel"
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="robot"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      style={{ width: widthSize }}
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
      />
    </SvgIcon>
  );
};

AgentIcon.propTypes = {
  widthSize: PropTypes.number,
  isFromGraph: PropTypes.bool
};

AgentIcon.defaultProps = {
  widthSize: 46,
  isFromGraph: false // Default to false
};

export default AgentIcon;
